module.exports = __webpack_public_path__ + "static/case4.png";